
export default {
  name: "BoxPhoto",
  props: {
    type: {
      type: String,
    },
    search: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      name: '',
    }
  },

  methods: {
    submit() {
      this.$store.commit('setUserName', this.name)
      this.name = ''
      if(this.type !== 'main') {
        this.$router.push('/')
      }
    }
  }
}
